import { render, staticRenderFns } from "./BoxBalanceDisplay.vue?vue&type=template&id=ff536c9a&"
import script from "./BoxBalanceDisplay.vue?vue&type=script&lang=js&"
export * from "./BoxBalanceDisplay.vue?vue&type=script&lang=js&"
import style0 from "./BoxBalanceDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports